export const TOP_HEADLINES_URL = "https://newsapi.org/v2/top-headlines?country=us&apiKey=";
export const NEW_API_KEY="865167854a744f11bcf18278caae619a";
export const INDIA_HEADLINES = "https://newsapi.org/v2/top-headlines?country=in&apiKey=";
export const INDIA_SPORTS_URL = "https://newsapi.org/v2/top-headlines?country=in&category=sports&apiKey=";
export const LAT_LON_URL = "http://api.openweathermap.org/geo/1.0/direct?"
export const WEATHER_URL = "http://api.openweathermap.org/data/2.5/forecast?"
export const WEATHER_API_KEY="0e3248bbde287def7352a89b3291f7c3"
